import { __makeTemplateObject } from 'tslib';
import { css } from 'styled-components';
import { font } from '../../theme/reset/index.js';

var baseStyles = function baseStyles(theme) {
  return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n  padding-top: 5px;\n\n  & .fi-chip-list_content_wrapper > * {\n    margin: 10px 10px 0 0;\n    padding-right: -10px;\n  }\n\n  & .fi-chip-list_content_wrapper {\n    display: inline-flex;\n    flex-wrap: wrap;\n    width: 100%;\n  }\n"], ["\n  ", "\n  padding-top: 5px;\n\n  & .fi-chip-list_content_wrapper > * {\n    margin: 10px 10px 0 0;\n    padding-right: -10px;\n  }\n\n  & .fi-chip-list_content_wrapper {\n    display: inline-flex;\n    flex-wrap: wrap;\n    width: 100%;\n  }\n"])), font(theme)('bodyText'));
};
var templateObject_1;

export { baseStyles };
//# sourceMappingURL=ChipList.baseStyles.js.map
